<template>
    <h1>not found 404</h1>
</template>
<script>
export default {};
</script>
